import ChargeBeeComponent from '@/views/ChargeBee.vue';
import RouteNames from '../constants/route-names';

const chargeBeeRoute = {
  component: ChargeBeeComponent,
  name: RouteNames.ChargeBee,
  path: '/chargebee',
  props: route => ({
    redirectParams: route.query.redirectParams,
  }),
};

export default chargeBeeRoute;
